import { Breadcrumb } from 'antd';
import { BreadcrumbProps } from 'antd/lib/breadcrumb';
import * as React from 'react';

export type NiBreadcrumbProps = BreadcrumbProps & {};
export type NiBreadcrumbState = {};

export class NiBreadcrumb extends React.Component<
  NiBreadcrumbProps,
  NiBreadcrumbState
> {
  static Item = Breadcrumb.Item;
  render() {
    return <Breadcrumb {...this.props} />;
  }
}
